import { IS_WEB } from 'constants/platform'
import React, { useMemo } from 'react'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Image } from 'widgets/Image'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import commonStyles from 'utils/styles/commonStyles'

type RowItemProps = {
  type?: 'circle' | 'square'
  title: string
  subTitle: string
  image: any
  onPress: () => void
  isSelected?: boolean
}

export const LaunchpadRow = ({
  type = 'square',
  title,
  subTitle,
  image,
  onPress,
  isSelected = false,
}: RowItemProps) => {
  const imageUrl = useMemo(() => {
    return IS_WEB ? { uri: image?.url ?? image } : image
  }, [image])

  return (
    <Pressable onPress={onPress} style={{ height: 80, width: '100%' }}>
      <Box height={80} width='100%' flexDirection='row' align='center' justifyContent='center'>
        <Box
          width={64}
          height={64}
          margin={{ horizontal: 'sm' }}
          backgroundColor='v2lightGrey'
          borderRadius={type === 'square' ? 'sm' : 'xl'}
          style={commonStyles.overflowHidden}
        >
          <Image style={commonStyles.fullSize} resizeMode='cover' source={imageUrl} />
        </Box>

        <Box flex={1} margin={{ left: 'sm', vertical: 'sm' }}>
          <Text bold color='v2black' numberOfLines={1}>
            {title}
          </Text>
          <Text fontSize='sm' color='v2midGrey' numberOfLines={1}>
            {subTitle}
          </Text>
        </Box>

        <Box margin='sm' align='center' justifyContent='center'>
          {isSelected && <Icon name='check' color='v2primary' />}
        </Box>
      </Box>
    </Pressable>
  )
}
